define( [
	"../../core"
], function( jQuery ) {
	return jQuery.now();
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/ajax/var/nonce.js
 ** module id = 887
 ** module chunks = 2
 **/